import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ScheduleItemForm from '@/components/content/ScheduleItemForm.vue';
import CurrentLanguage from '@/components/CurrentLanguage.vue';
import { ScheduleItem } from '@/models/schedule-item.model';
import { useEvents, Event } from '@/services/events.composable';
import { Mutations, ShiftCMSState } from '@/store';
import { ContentStoreActions, ContentStoreState } from '@/stores/content.store';
import { format, parse } from 'date-fns';
import { computed, markRaw, onBeforeUnmount, onMounted } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContentSchedules',
  setup(__props) {

const store = useStore<ShiftCMSState & { cns: ContentStoreState }>();
const events = useEvents();

const scheduleItems = computed<ScheduleItem[]>(
  () => store.state.cns.scheduleItems,
);

const update = () => {
  store.dispatch(ContentStoreActions.GetSchedules);
};

onMounted(() => {
  events.on(Event.UpdateContentItem, update);
  events.on(Event.LanguageChanged, update);
  update();
});

onBeforeUnmount(() => {
  events.off(Event.UpdateContentItem, update);
  events.off(Event.LanguageChanged, update);
});

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Date', key: 'date', width: '15%' },
  { title: 'Description', key: 'description', width: '30%' },
  { title: 'Initiative', key: 'initiative', width: '25%' },
];

const editItem = (_: MouseEvent, rowData: { item: ScheduleItem }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(ScheduleItemForm),
    data: rowData.item,
  });
};

const addItem = () => {
  const item: ScheduleItem = {
    id: -1,
    description: '',
    date: format(new Date(), 'dd-MM-yyyy'),
    initiative: null,
  };

  store.commit(Mutations.ShowDrawer, {
    component: markRaw(ScheduleItemForm),
    data: item,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createElementVNode("h2", null, [
        _cache[1] || (_cache[1] = _createTextVNode("Scheduled Initiatives ")),
        _createVNode(CurrentLanguage)
      ]),
      _createVNode(_component_v_data_table, {
        density: "compact",
        headers: headers,
        items: scheduleItems.value,
        "onClick:row": _withModifiers(editItem, ["prevent"]),
        itemsPerPage: "25",
        hover: ""
      }, {
        "item.date": _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(_unref(format)(_unref(parse)(item.date, 'dd-MM-yyyy', new Date()), 'MMMM do yyyy')), 1)
        ]),
        "item.initiative": _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(item.initiative!.title), 1)
        ]),
        _: 1
      }, 8, ["items"]),
      _createVNode(_component_v_btn, {
        color: "success",
        onClick: _cache[0] || (_cache[0] = () => addItem())
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("Add Schedule")
        ])),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})